import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';
import { useManufacturer } from './ManufacturerStore';
import { useCountries } from '../Countrys/CountryStore';

function Add(props) {
    let { createManufacturer } = useManufacturer()
    let {countries, getCountries} = useCountries()
    let [logo, setLogo] = useState(null)
    let [previewVisible, setPreviewVisible] = useState(false)
    let handleSelect = (e) => {
        setLogo(e)
    }
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue({
            logo: logo
        })
    }, [logo])

    useEffect(() => {
        getCountries()
    }, [])
    return (
        <>
            <Modal open={previewVisible} footer={null} width={'80%'} onCancel={() => setPreviewVisible(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Form form={form} layout="vertical" onFinish={createManufacturer} encType="multipart/form-data">
                <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Logotip" name="logo">
                    <Input readOnly suffix={<Button type="primary" onClick={() => setPreviewVisible(true)}>Fayl yuklash</Button>} />
                </Form.Item>
                <Form.Item label="Davlat" name="country_id">
                    <Select options={countries.map(country => ({ label: country.nameuz, value: country.id }))} showSearch optionFilterProp="label" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Qo'shish</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Add;